// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zsdjntwxhhwotqpdwcdg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzZGpudHd4aGh3b3RxcGR3Y2RnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ2MjU5ODAsImV4cCI6MjA2MDIwMTk4MH0.y4nKrG5CkwH1zfdtSrQSgcPXvZKPxkw2RrCOeRWHPds";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);